import React, { useContext } from "react";
import { GlobalState } from "../../Helper/Context";
const ListIcon = () => {
  const { state, setState } = useContext(GlobalState);

  return (
    <svg
      onClick={() => {
        setState({ ...state, listMode: "list" });
        localStorage.setItem("listMode", "list");
      }}
      className="h-8 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="25.333"
      height="19"
      viewBox="0 0 25.333 19"
    >
      <path
        id="svg_46762"
        d="M57.333,65.5a1.056,1.056,0,0,1-1.056,1.056H33.056a1.056,1.056,0,0,1,0-2.111H56.278A1.056,1.056,0,0,1,57.333,65.5ZM33.056,58.111H56.278a1.056,1.056,0,1,0,0-2.111H33.056a1.056,1.056,0,1,0,0,2.111ZM56.278,72.889H33.056a1.056,1.056,0,0,0,0,2.111H56.278a1.056,1.056,0,0,0,0-2.111Z"
        transform="translate(-32 -56)"
        opacity={state.listMode == "list" ? 1 : 0.3}
      />
    </svg>
  );
};

export default ListIcon;
